import * as React from 'react';

import SignMeOthers32 from './SignMeOthers32';

export const signMeOthers32 = () => <SignMeOthers32 />;

export default {
    title: 'Icon/Fill/SignMeOthers32',
    component: SignMeOthers32,
    parameters: {
        notes: "`import SignMeOthers32 from 'box-ui-elements/es/icon/fill/SignMeOthers32';`",
    },
};
